// A seam for pages that handle their own navigation.
//
// `actionDelegator`'s `navigate` / `navigate-value` handlers are `location.href = href` and
// must stay that way — 25 of the 26 pages are server-rendered and a link is a link. But
// /dashboard renders itself in the browser, so a tab click there should swap the view
// rather than reload the document.
//
// Rather than teach the delegator about the dashboard, the dashboard registers a handler
// here and the delegator asks. Nothing else in the bundle knows either side exists.
//
// Deliberately a single slot rather than a list: two pages cannot both be on screen, and a
// list would make "which one answered?" a question worth asking.

/** Returns true if it took ownership of `href`; false to let the browser navigate. */
type ClientNavigator = (href: string) => boolean;

let navigator: ClientNavigator | null = null;

export function registerClientRoute(fn: ClientNavigator): void {
  navigator = fn;
}

/**
 * Offer `href` to the registered page router.
 *
 * Returns false when nothing is registered, when the router declines, or if it throws —
 * the caller then does a normal navigation, so a broken router costs a page load rather
 * than a dead link.
 */
export function tryClientNavigate(href: string): boolean {
  if (!navigator) return false;
  try {
    return navigator(href);
  } catch (err: unknown) {
    console.error("client route failed; falling back to a full navigation", err);
    return false;
  }
}
